<template>
    <BasePanel
        :headline="$t('lang_LABEL_RELEASES')+' (' + this.listItemsLength + ')'"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="100"
            >
            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.title`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-release-title'">
                        {{ item.title }}
                    </div>
                </template>
                <template v-slot:[`item.tracks`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-text-tracks'"
                    >
                        {{ item.tracks }}
                    </div>
                </template>
                <template v-slot:[`item.displayArtist`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-display-artist'">
                        {{ item.displayArtist }}
                    </div>
                </template>
                <template v-slot:[`item.ean`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-ean'">
                        {{ item.ean }}
                    </div>
                </template>
                <template v-slot:[`item.catalogueNumber`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-catalogue-number'">
                        {{ item.catalogueNumber }}
                    </div>
                </template>
                <template v-slot:[`item.dateRetail`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-date-retail'">
                        {{ item.dateRetail !== null ? $d(new Date(item.dateRetail), 'alvDateFormat') : ''  }}
                    </div>
                </template>
                <template v-slot:[`item.dateDigital`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-date-digital'">
                        {{ item.dateDigital !== null ? $d(new Date(item.dateDigital), 'alvDateFormat') : ''  }}
                    </div>
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'

export default {
    name: 'LabelProjectsReleasesReadOnlyPanel',
    components: {
        BasePanel
    },
    props: {
        projectsAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'label-projects-list-row-' + this.projectsAlvId + '-read-only-panel-releases'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_TITLE'), 
                    value: 'title', 
                    align: 'left', 
                    sortable: true,
                    class: 'text-no-wrap'
                }, 
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_NUMBER_OF_TRACKS'), 
                    value: 'tracks',
                    align: 'right', 
                    sortable: false,
                    width: "100px",
                    class: 'text-no-wrap'
                }, 
                {
                    text: this.$t('lang_LABEL_RELEASE_CAPTION_DISPLAY_ARTIST'), 
                    value: 'displayArtist',
                    align: 'left', 
                    sortable: true,
                    class: 'text-no-wrap'
                }, 
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_EAN_UPC'), 
                    value: 'ean',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_LABEL_RELEASE_CAPTION_CATALOGUE_NUMBER'), 
                    value: 'catalogueNumber', 
                    align: 'left', 
                    sortable: true, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_DATE_PHYSICAL'), 
                    value: 'dateRetail', 
                    align: 'left', 
                    sortable: true, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_DATE_DIGITAL'), 
                    value: 'dateDigital',
                    align: 'left', 
                    sortable: true, 
                    class: 'text-no-wrap'
                },
            ]
        },
        listItems() { return this.$store.getters.getLabelProjectsReleases },
        listItemsLength() { return this.$store.getters.getLabelProjectsReleases.length }
    }
}
</script>